// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import SchoolClassCheckIn from "./school-class-check-in.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "SchoolClassCheckInEvent",
  "collectionKey": "school_class_check_in_events",
  "collectionName": "school_class_check_in_events",
  "i18nKey": "school_class_check_in_event",
  "camelizedLower": "schoolClassCheckInEvent",
  "name": "SchoolClassCheckInEvent",
  "nameDasherized": "school-class-check-in-event",
  "pluralName": "school_class_check_in_events",
  "ransackable_associations": [
    {
      "className": "SchoolClassCheckInEvent::Audit",
      "collectionName": "school_class_check_in_event_audits",
      "foreignKey": "school_class_check_in_event_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SchoolClassCheckInEventAudit",
      "through": null
    },
    {
      "className": "SchoolClassCheckInEvent::Audit",
      "collectionName": "school_class_check_in_event_audits",
      "foreignKey": "school_class_check_in_event_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SchoolClassCheckInEventAudit",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "School",
      "through": "school_class"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "school_class_check_in"
    },
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "event_type",
      "column": {
        "default": null,
        "name": "event_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "school_class_check_in_id",
      "column": {
        "default": null,
        "name": "school_class_check_in_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SchoolClassCheckIn",
      "collectionName": "school_class_check_ins",
      "foreignKey": "school_class_check_in_id",
      "name": "school_class_check_in",
      "macro": "belongs_to",
      "resource_name": "SchoolClassCheckIn",
      "through": null
    }
  ],
  "paramKey": "school_class_check_in_event",
  "primaryKey": "id"
}

/** Frontend model for SchoolClassCheckInEvent. */
export default class SchoolClassCheckInEvent extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./school-class-check-in.js").default | null} */
  schoolClassCheckIn() {
    return this._readBelongsToReflection({modelClass: SchoolClassCheckIn, reflectionName: "school_class_check_in"})
  }

  /** @returns {Promise<import("./school-class-check-in.js").default | null>} */
  loadSchoolClassCheckIn() {
    if (!("schoolClassCheckInId" in this)) throw new Error("Foreign key method wasn't defined: schoolClassCheckInId")

    const id = this.schoolClassCheckInId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "school_class_check_in",
        model: this,
        modelClass: SchoolClassCheckIn
      },
      {ransack}
    )
  }
}
